module.exports = __webpack_public_path__ + "img/GAME_SOCCER.033b1e57.jpg";